@if (currentUser$ | async; as currentUser) {
  <div
    class="user-information-container"
    (click)="avatarClicked.emit()">
    <app-user-avatar [size]="45" [user]="currentUser" />
    <div class="user-details-container">
      <span class="display-name-text"> {{ currentUser.displayName }}</span>
      <span class="email-text"> {{ currentUser.email }}</span>
    </div>
  </div>
}
